module.exports = __webpack_public_path__ + "img/icon-go.2a537c7c.svg";